<template>
    <div class="bid-plan-change-audit">
        <div class="title-container">
            <span class="sub-title">招采计划修改审批</span>
            <i :class="contentVisible ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click="handleCollapse"></i>
        </div>
        <div class="content" v-show="contentVisible">
            <Info :bidPlanId="bidPlanId" :fdId="fdId" />
        </div>
    </div>
</template>
<script>
import Info from './Info.vue'
export default {
    components: { Info },
    props: {
        bidPlanId: {
            type: String,
            default: '',
        },
        fdId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            contentVisible: true
        }
    },
    methods: {
        handleCollapse() {
            this.contentVisible = !this.contentVisible
        },
    }
}
</script>

<style lang="less" scoped>
.bid-plan-change-audit {
    margin-bottom: 20px;

    .sub-title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-top: 10px;
        margin-bottom: 15px;

        i {
            float: right;
            padding-right: 10px;
            font-size: 24px;
            cursor: pointer;
        }
    }

    .content {
        overflow-x: scroll;
    }
}
</style>